<section class="container-fluid temp-color">
  <div class="row">
    <div class="col-sm-2">
      <h3 id="left-nav-heading" class="content-title">Wilshire</h3>
      <security-navigation> </security-navigation>
    </div>
    <div class="col-sm-10">
      <div class="box summary compartment">
        <div>
          <div class="section__header">
            <h2 id="matrix-document-title" class="content-title">{{title}}</h2>
            @if (successMessage?.message?.length > 0) {
              <div class="margin-bottom">
                <nfrp-alert id="toggleSuccess" alertId="togglePlanSendInd-success" type="success" [message]="successMessage" [page]="false"> </nfrp-alert>
              </div>
            }
            @if (errorMessage?.message?.length > 0) {
              <div class="margin-bottom">
                <nfrp-alert id="toggleError" alertId="togglePlanSendInd-error" [message]="errorMessage" type="error" [page]="false"> </nfrp-alert>
              </div>
            }
          </div>
          <div class="content">
            <div>
              <div class="input-container">
                <!-- <span class="input-search padding-left"> -->
                <label for="plan-autocomplete-input" class="input-label">Add Plan:</label>
                <!-- <label>Add Plan:</label> -->
                <autocomplete
                  [searchValue]="planSearchText"
                  (filterSearch)="filterSearch($event)"
                  (clickAway)="onClickAway()"
                  [placeHolder]="'Plan Name or Number'"
                  [id]="'plan-autocomplete-input'"
                  [disabled]="disableForProcessing"
                ></autocomplete>
                @if (showPlanResults) {
                  <div class="auto-complete">
                    <ul>
                      @for (option of options; track option; let i = $index) {
                        <li id="auto-complete-list-item-{{i}}" (click)="selectedPlan(option)">
                          {{ option.displayString }}
                        </li>
                      }
                      @if (!options) {
                        <div>
                          <li id="auto-complete-no-results">
                            No results found
                          </li>
                        </div>
                      }
                    </ul>
                  </div>
                }
              <!-- </span> -->
              @if (sendAllPlansSpinner) {
                <nfrp-spinner size="small"></nfrp-spinner>
              }
              <div class="button-group">
                <input
                  id="send-all-button"
                  class="button-primary button no-margin-top"
                  type="submit"
                  size="40"
                  value="Send All Plans"
                  style="margin: 0 0 0 10px;"
                  [disabled]="disableForProcessing"
                  (click)="handleSendAllPlans()"
                  />
                  <input
                    id="remove-all-button"
                    class="button-primary button no-margin-top"
                    type="submit"
                    size="40"
                    value="Remove All Non-Error Plans"
                    style="margin: 0 0 0 10px;"
                    [disabled]="disableForProcessing"
                    (click)="handleRemoveAllPlans()"
                    />
                  </div>
                </div>
              </div> <!-- (click)="searchUserByUserType()" -->
              <!--- start new new table-->
              <form > <!-- [formGroup]="markedPlanFunds" -->
                @if (dataSource) {
                  <ng-template #headerTemplate>
                    <div nfrpColumn [width]="14" widthType="%" [id]="'plan-number'">
                      Plan Number
                      <nfrp-grid-sorter [column]="'planNo'" dataType="string" (sort)="sort($event)"> </nfrp-grid-sorter>
                    </div>
                    <div nfrpColumn [width]="35" widthType="%" [id]="'plan-name'">
                      Plan Name
                      <nfrp-grid-sorter [column]="'planDesc'" dataType="string" (sort)="sort($event)"> </nfrp-grid-sorter>
                    </div>
                    <div nfrpColumn [width]="25" widthType="%" [id]="'error-reason'">
                      Error Reason
                    </div>
                    <div nfrpColumn [width]="10" widthType="%" [id]="'create-date'" class="wilshireCreatedDate">
                      Created <br>Date
                    </div>
                    <div nfrpColumn [width]="10" widthType="%" [id]="'create-date'" class="wilshireSendTo">
                      Send To<br>Wilshire<br>
                    </div>
                    <div nfrpColumn [width]="5" widthType="%" [id]="'delete-row'" class="wilshireDeleteRow">
                      &nbsp;
                    </div>
                  </ng-template>
                  <ng-template #rowTemplate let-planFundResult="item" let-index="index">
                    <div>
                      <div [id]="'plan-number-' + index">
                        {{ planFundResult.planNo | nfrpNormalizeValue: '-' }}
                      </div>
                      <div [id]="'plan-name-' + index">
                        {{ planFundResult.planDesc | nfrpNormalizeValue: '&nbsp;' }}
                      </div>
                      <div [id]="'error-reason-' + index" class="wilshireErrorReason">
                        {{ planFundResult.errorReason | nfrpNormalizeValue: '&nbsp;' }}
                      </div>
                      <div [id]="'create-date-' + index" class="wilshireCreatedDate">
                        {{ (planFundResult.createdDate | date:'yyyy-MM-dd') ?? '&nbsp;' }}
                      </div>
                      <div [id]="'send-to-wilshire-' + index" class="wilshireSendTo">
                        <input
                          type="checkbox"
                          id="plan-number-{{ index }}"
                          [checked]="planFundResult.flaggedToSendInd === 'Y'"
                          [disabled]="disableForProcessing"
                          (change)="togglePlanSendInd($event, planFundResult.planNo)"
                          />
                        </div>
                        <div [id]="'delete-row-' + index" class="wilshireDeleteRow" [ngClass]="{'disabled-div': disableForProcessing}">
                          <span
                            class="icon-delete icon-button"
                            id="{{ 'delete-plan-' + index }}"
                            (click)="handleDeletePlan(planFundResult)"
                          ></span>
                        </div>
                      </div>
                    </ng-template>
                    <nfrp-grid
                      [headerTemplate]="headerTemplate"
                      [rowTemplate]="rowTemplate"
                      [iterable]="data"
                      [width]="100"
                      rowIdPrefix="seach-plan-details"
                    ></nfrp-grid>
                    <nfrp-grid-paginator
                      (paginate)="paginate($event)"
                      [numberOfItems]="numberOfItems"
                      [itemsPerPageOptions]="[5, 10, 20, 50]"
                      [defaultItemsPerPage]="5"
                    ></nfrp-grid-paginator>
                  } @else {
                    <nfrp-spinner></nfrp-spinner>
                  }
                </form><!-- {{ planFundResult$.planNo }} deletePlan? {{ deletePlan?.planNo }}-->
                <nfrp-default-modal
                  header="Remove Plan"
                  message="Are you sure you want to remove this plan?"
                  noButtonValue="No"
                  yesButtonValue="Yes"
                  [showModal]="showRemovePlanModal"
                  (noClicked)="handleDeletePlanNo()"
                  (yesClicked)="handleDeletePlanYes()"
                ></nfrp-default-modal>
                <!-- END New table-->



              </div>
            </div>
            <nfrp-default-modal
              id="add-plan-modal"
              header="Add Plan"
              [message]="planToAddMessage"
              noButtonValue="No"
              yesButtonValue="Yes"
              [showModal]="addPlanModal"
              (noClicked)="addPlanForFlaggingNo()"
              (yesClicked)="addPlanForFlaggingYes()"
            ></nfrp-default-modal>
            <nfrp-default-modal
              id="send-all-plans-modal"
              header="Send All Plans"
              [message]="sendAllPlansMessage"
              noButtonValue="No"
              yesButtonValue="Yes"
              [showModal]="showSendAllPlansModal"
              (noClicked)=" handleSendAllPLansNo()"
              (yesClicked)="handleSendAllPLansYes()">
            </nfrp-default-modal>
            <nfrp-default-modal
              id="remove-all-plans-modal"
              header="Remove All Non-Error Plans"
              [message]="removeAllPlansMessage"
              noButtonValue="No"
              yesButtonValue="Yes"
              [showModal]="showRemoveAllPlansModal"
              (noClicked)="handleRemoveAllPlansNo()"
              (yesClicked)="handleRemoveAllPlansYes()">
            </nfrp-default-modal>
            <!-- <router-outlet></router-outlet> -->
          </div>
        </div>
      </div>
    </section>
